export enum ShareRecommendationMethod {
  PRINT = 'print',
  EMAIL = 'email',
  QRCODE = 'qrcode',
}
